module.exports = __webpack_public_path__ + "static/media/8.76c5edba.jpg";